<template>
	
<div class="risk">

	<div class="risk-title">{{ section.summary.risk.title }}</div>
	
	<div class="risk-content">

		<div class="risk-density" v-if="density">

			<div class="risk-density-title">Bone density results</div>

			<div class="risk-density-scale">

				<div class="risk-density-scale-score" v-if="density !== false">

					<div :style="{left: densityLeft}"><small>Your T Score</small><span>{{ densityText }}</span></div>

				</div>

				<div class="risk-density-scale-values">
					<div>0</div>
					<div>-1</div>
					<div>-2</div>
					<div>-3</div>
					<div>-4</div>
				</div>

				<div class="risk-density-scale-labels">
					<div>Normal</div>
					<div>Low Bone Density</div>
					<div>Osteoporosis</div>
				</div>

			</div>

		</div>

		<div class="risk-score">

			<div class="risk-score-title">Chance of breaking a bone <small>Fracture* risk score</small></div>

			<div class="risk-score-value">
				{{ score }}<small>in</small>100
			</div>

			<div class="risk-score-percent">
				<span>{{ score }}%</span> in the next 10 years
			</div>

			<div class="risk-score-note">* A fracture is the same as a break</div>

		</div>

	</div>

</div>

</template>

<script>

export default {

	props: ['section'],

	computed: {

		density: function() {

			var score = this.$store.getters['session/values'][this.$store.getters['logic/variable/named']['ref.lowest']]
			
			return (score === null) ? false : parseFloat(score).toFixed(1)

		},

		densityLeft: function() {

			var points = {
				'0': 5,
				'-0': 5,
				'-1': 76,
				'-2': 147,
				'-3': 217,
				'-4': 287
			}

			var parts = this.density.toString().split('.')

			var left = 0

			var original = parts[0]

			if (parts[0] > 0) parts[0] = 0
			if (parts[0] < -4) parts[0] = -4

			left = points[parts[0]]

			var increment = (this.density > 0) ? -1 : 1

			if (parts[1] !== '0' && original <= 0 && original >= -3) {

				left += ((points[(parseInt(parts[0]) - increment).toString()] - left) / 10) * parseInt(parts[1])

			}

			return left + 'px'

		},

		densityText: function() {

			return this.density.toString()
		
		},

		score: function() {

			return Math.round(this.frax('major'))

		}

	}
	
}

</script>

<style scoped>

.risk {
	border-bottom: 1px solid var(--aid-color);
	padding-bottom: 32px;
	margin-bottom: 32px;
}

.is-pdf .risk {
	margin-bottom: 0px;
	border-bottom: 0px;
	padding-bottom: 30px;
}

.risk-title {
	color: #343434;
	margin-bottom: 32px;
	font-size: 20px;
	text-transform: uppercase;
	font-weight: 600;
}

.is-pdf .risk-title {
	margin-bottom: 10px;
	font-size: 16px;
}

.risk-content {
	flex-direction: row;
	display: flex;
}

.risk-density,
.risk-score {
	flex-grow: 1;
	flex-shrink: 0;
	flex-basis: 0;
}

.risk-density-scale {
	width: 359px;
	margin: 0px auto;
	margin-top: 112px;
	height: 43px;
	background-image: url(~@/assets/aid/risk/density/scale.svg);
	background-position: 50% 50%;
	background-repeat: no-repeat;
}

.risk-density-scale-values {
	width: 100%;
	position: absolute;
	top: -8px;
	font-size: 12px;
	display: flex;
	flex-direction: row;
	font-weight: 600;
	color: #343434;
}

.risk-density-scale-values div:nth-child(1) { margin-left: 34px; width: 64px; }
.risk-density-scale-values div:nth-child(2) { width: 76px; }
.risk-density-scale-values div:nth-child(3) { width: 70px; }
.risk-density-scale-values div:nth-child(4) { width: 70px; }

.risk-density-scale-labels {
	width: 100%;
	position: absolute;
	top: 48px;
	font-size: 12px;
	display: flex;
	flex-direction: row;
	font-weight: 600;
	color: #343434;
}

.risk-density-scale-labels div {
	text-align: center;
	padding: 0px 10px;
}

.risk-density-scale-labels div:nth-child(1) { margin-left: 30px; width: 72px; }
.risk-density-scale-labels div:nth-child(2) { width: 114px; border-left: 2px dashed #3FB194; border-right: 2px dashed #3FB194; }
.risk-density-scale-labels div:nth-child(3) { width: 110px; }

.risk-density-scale-score {
	position: absolute;
	top: -24px;
	left: 32px;
	width: 296px;
	height: 1px;
}

.risk-density-scale-score div {
	position: absolute;
	bottom: 0px;
	margin-left: -55px;
	width: 111px;
	height: 75px;
	background-color: #343434;
	border-radius: 16px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	color: #fff;
	font-weight: 600;
}

.risk-density-scale-score div small {
	font-size: 12px;
	margin-bottom: 4px;
	letter-spacing: 1px;
}

.risk-density-scale-score div span {
	font-size: 35px;
	letter-spacing: 2px;
}

.risk-density-scale-score div:after {
	content: ' ';
	position: absolute;
	width: 20px;
	height: 10px;
	background-color: #343434;
	bottom: -9px;
	left: 50%;
	margin-left: -10px;
	clip-path: polygon(0px 0px, 100% 0px, 50% 100%);
}

.risk-score {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.risk-density-title,
.risk-score-title {
	color: #343434;
	text-transform: uppercase;
	font-size: 18px;
	letter-spacing: 2px;
	font-weight: 600;
	text-align: center;
	margin-bottom: 30px;
}


.is-pdf .risk-density-title,
.is-pdf .risk-score-title {
	font-size: 14px;
	margin-bottom: 20px;
}

.risk-score-title small {
	display: block;
	font-size: 12px;
	letter-spacing: 1px;
	margin-top: 2px;	
}

.risk-score-value {
	font-size: 65px;
	text-transform: uppercase;
	color: #343434;
	font-weight: 600;
	text-align: center;
}

.risk-score-value small {
	font-size: 16px;
	vertical-align: baseline;
	margin: 0px 10px;
}

.risk-score-percent {
	line-height: 32px;
	color: #343434;
	font-size: 14px;
	text-align: center;
	letter-spacing: 1px;
	font-weight: 600;
	margin-bottom: 30px;
}

.risk-score-percent span {
	font-size: 20px;
}

.risk-score-note {
	text-align: center;
	letter-spacing: 1px;
	font-size: 12px;
	font-weight: 600;
	color: #343434;
}

</style>